{
  "invalidSelection": "选定的 {selectedCount, plural, one {个日期} other {个日期}} 不可用。"
}
